"use client";

import React from "react";
// import { CircularProgressBar } from "@tomik23/react-circular-progress-bar";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

// const propss = {
//   percent: -34, // is require
//   colorSlice: "#33cc33",
//   colorCircle: "#d7f3e1",
//   fontColor: "#365b74",
//   fontSize: "1.6rem",
//   fontWeight: 400,
//   size: 200,
//   stroke: 10,
//   // strokeBottom: 5,
//   speed: 60,
//   cut: 0,
//   rotation: -90,
//   // opacity: 10,
//   // fill: "#000",
//   unit: "%",
//   textPosition: "0.35em",
//   animationOff: false,
//   // strokeDasharray: "10,1",
//   inverse: false,
//   round: false,
//   number: false,
//   // linearGradient: ["#ffff00", "brown"],
// };
// const percentage = -34;

export default function MyCircularProgressBar({ ...props }) {
  return (
    <CircularProgressbar
      strokeWidth={14}
      minValue={0}
      value={props.value}
      text={`${props.value + (!props.isNumber ? " %" : null)}`}
      counterClockwise={props.counterClockwise}
      styles={buildStyles({
        // Rotation of path and trail, in number of turns (0-1)
        // rotation: 0.25,

        // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
        strokeLinecap: "round",

        // Text size
        textSize: "16px",
        // text: {
        //   // Text color
        //   fill: "#33cc33",
        //   // Text size
        //   fontSize: "14px",
        // },

        // How long animation takes to go from one percentage to another, in seconds
        pathTransitionDuration: 0.5,

        // Can specify path transition in more detail, or remove it entirely
        // pathTransition: 'none',

        // Colors
        pathColor: props.pathColor,
        textColor: props.textColor,
        trailColor: props.trailColor,
        // backgroundColor: "#3e98c7",
      })}
    />
  );
}
